module.exports = __webpack_public_path__ + "img/9bc6b55.jpg";